import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth'
import loader from './modules/loader'

import { abilityPlugin } from '../helpers/abilities'

import organization from './modules/controllers/organization'
import account from './modules/controllers/account'
import service from './modules/controllers/service'
import platform from './modules/controllers/platform'
import label from './modules/controllers/label'
import conversation from './modules/controllers/conversation'
import inbox from './modules/controllers/inbox'
import flow from './modules/controllers/flow'
import block from './modules/controllers/block'
import flow_group from './modules/controllers/flow_group'
import post from './modules/controllers/post'
import facebook from './modules/controllers/facebook'
import instagram from './modules/controllers/instagram'
import answer from './modules/controllers/answer'
import topic from './modules/controllers/topic'
import kpi from './modules/controllers/kpi'
import user from './modules/controllers/user'
import broadcast from './modules/controllers/broadcast'
import sequence from './modules/controllers/sequence'
import follow_up_action from './modules/controllers/follow_up_action'
import rule from './modules/controllers/rule'
import lambda from './modules/controllers/lambda'
import extension from './modules/controllers/extension'
import entity from './modules/controllers/entity'
import product from './modules/controllers/product'
import variant from './modules/controllers/variant'
import product_variant from './modules/controllers/product_variant'
import category from './modules/controllers/category'
import order from './modules/controllers/order'
import report from './modules/controllers/report'
import location from './modules/controllers/location'
import delivery from './modules/controllers/delivery'
import user_attribute from './modules/controllers/user_attribute'
import account_attribute from './modules/controllers/account_attribute'
import metric from './modules/controllers/metric'
import metric_attribute from './modules/controllers/metric_attribute'
import group from './modules/controllers/group'
import tag from './modules/controllers/tag'
import tag_category from './modules/controllers/tag_category'
import caseResource from './modules/controllers/case'
import case_note from './modules/controllers/case_note'
import parameter from './modules/controllers/parameter'
import response_template from './modules/controllers/response_template'
import keyword from './modules/controllers/keyword'
import helpers from './modules/controllers/helpers'
import admin from './modules/controllers/admin'
import role from './modules/controllers/role'
import public_media from './modules/controllers/public_media'
import question from './modules/controllers/question'
import bmessaging from './modules/controllers/bmessaging'
import bmessaging_domain from './modules/controllers/bmessaging_domain'
import bmessaging_menu from './modules/controllers/bmessaging_menu'
import bmessaging_card from './modules/controllers/bmessaging_card'
import plan_payment from './modules/controllers/plan_payment'
import plan from './modules/controllers/plan'
import partner from './modules/controllers/partner'
import milestone from './modules/controllers/milestone'
import template from './modules/controllers/template'
import template_connector from './modules/controllers/template_connector'
import template_attribute from './modules/controllers/template_attribute'
import element from './modules/controllers/element'
import element_attribute from './modules/controllers/element_attribute'
import element_connector from './modules/controllers/element_connector'
import model from './modules/controllers/model'
import card from './modules/controllers/card'
import merchant from './modules/controllers/merchant'
import reference from './modules/controllers/reference'
import filter from './modules/controllers/filter'
import kanguro from './modules/controllers/kanguro'
import message from './modules/controllers/message'
import suggestion from './modules/controllers/sam_message'
import knowledge from './modules/controllers/knowledge'
import contact from './modules/controllers/contact'
import stripe from './modules/controllers/stripe'
import paypal from './modules/controllers/paypal'
import certification_exam from './modules/controllers/certification_exam'
import notification from './modules/controllers/notification'
import insights from './modules/controllers/insights'
import feedback from './modules/controllers/feedback'
import objective from './modules/controllers/objective'
import list from './modules/controllers/list'
import graph_answer from './modules/controllers/graph_answer'
import message_template from './modules/controllers/message_template'
import response_block from './modules/controllers/response_block'
import activity_log from './modules/controllers/activity_log'
import voicebot from './modules/controllers/voicebot'
import alexa from './modules/controllers/alexa'
import webhook from './modules/controllers/webhook'
import api_user from './modules/controllers/api_user'
import functions from './modules/controllers/functions'
import inbox_filters from './modules/controllers/inbox_filters'
import whatsapp from './modules/controllers/whatsapp'
import clipboard from './modules/controllers/clipboard'
import permissions from './modules/controllers/permission'
import productsPackage from './modules/controllers/products_package'
import documents from './modules/controllers/documents'
import bills from './modules/controllers/bill'
import property from './modules/controllers/property'
import property_filter from './modules/controllers/property_filter'
import googleapis_credential from './modules/controllers/googleapis_credential'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    abilityPlugin
  ],
  state: {
    sidenav_open: false,
    sidenav_close: false
  },
  getters: {
    isSidenavOpen (state) {
      return state.sidenav_open
    },
    isSidenavClose (state) {
      return state.sidenav_close
    }
  },
  mutations: {
    changeState (state, data) {
      try {
        state[data.action] = data.value
      } catch (e) {
        console.error('changeState error:', e.message)
      }
    }
  },
  actions: {
    closeSidenav ({ commit }, value) {
      commit('changeState', {
        action: 'sidenav_close',
        value: !!value
      })
    },
    openSidenav ({ commit }, value) {
      commit('changeState', {
        action: 'sidenav_open',
        value: !!value
      })
    }
  },
  modules: {
    clipboard: {
      namespaced: true,
      ...clipboard
    },
    auth: {
      namespaced: true,
      ...auth
    },
    loader: {
      namespaced: true,
      ...loader
    },
    organization: {
      namespaced: true,
      ...organization
    },
    account: {
      namespaced: true,
      ...account
    },
    service: {
      namespaced: true,
      ...service
    },
    platform: {
      namespaced: true,
      ...platform
    },
    label: {
      namespaced: true,
      ...label
    },
    conversation: {
      namespaced: true,
      ...conversation
    },
    inbox: {
      namespaced: true,
      ...inbox
    },
    flow: {
      namespaced: true,
      ...flow
    },
    flow_group: {
      namespaced: true,
      ...flow_group
    },
    block: {
      namespaced: true,
      ...block
    },
    post: {
      namespaced: true,
      ...post
    },
    facebook: {
      namespaced: true,
      ...facebook
    },
    instagram: {
      namespaced: true,
      ...instagram
    },
    answer: {
      namespaced: true,
      ...answer
    },
    topic: {
      namespaced: true,
      ...topic
    },
    kpi: {
      namespaced: true,
      ...kpi
    },
    user: {
      namespaced: true,
      ...user
    },
    broadcast: {
      namespaced: true,
      ...broadcast
    },
    sequence: {
      namespaced: true,
      ...sequence
    },
    follow_up_action: {
      namespaced: true,
      ...follow_up_action
    },
    rule: {
      namespaced: true,
      ...rule
    },
    lambda: {
      namespaced: true,
      ...lambda
    },
    extension: {
      namespaced: true,
      ...extension
    },
    entity: {
      namespaced: true,
      ...entity
    },
    product: {
      namespaced: true,
      ...product
    },
    variant: {
      namespaced: true,
      ...variant
    },
    product_variant: {
      namespaced: true,
      ...product_variant
    },
    category: {
      namespaced: true,
      ...category
    },
    order: {
      namespaced: true,
      ...order
    },
    report: {
      namespaced: true,
      ...report
    },
    location: {
      namespaced: true,
      ...location
    },
    delivery: {
      namespaced: true,
      ...delivery
    },
    user_attribute: {
      namespaced: true,
      ...user_attribute
    },
    account_attribute: {
      namespaced: true,
      ...account_attribute
    },
    metric: {
      namespaced: true,
      ...metric
    },
    metric_attribute: {
      namespaced: true,
      ...metric_attribute
    },
    group: {
      namespaced: true,
      ...group
    },
    tag: {
      namespaced: true,
      ...tag
    },
    tag_category: {
      namespaced: true,
      ...tag_category
    },
    case: {
      namespaced: true,
      ...caseResource
    },
    case_note: {
      namespaced: true,
      ...case_note
    },
    parameter: {
      namespaced: true,
      ...parameter
    },
    response_template: {
      namespaced: true,
      ...response_template
    },
    keyword: {
      namespaced: true,
      ...keyword
    },
    helpers: {
      namespaced: true,
      ...helpers
    },
    admin: {
      namespaced: true,
      ...admin
    },
    role: {
      namespaced: true,
      ...role
    },
    public_media: {
      namespaced: true,
      ...public_media
    },
    question: {
      namespaced: true,
      ...question
    },
    bmessaging: {
      namespaced: true,
      ...bmessaging
    },
    bmessaging_domain: {
      namespaced: true,
      ...bmessaging_domain
    },
    bmessaging_menu: {
      namespaced: true,
      ...bmessaging_menu
    },
    bmessaging_card: {
      namespaced: true,
      ...bmessaging_card
    },
    plan: {
      namespaced: true,
      ...plan
    },
    partner: {
      namespaced: true,
      ...partner
    },
    plan_payment: {
      namespaced: true,
      ...plan_payment
    },
    milestone: {
      namespaced: true,
      ...milestone
    },
    template: {
      namespaced: true,
      ...template
    },
    template_connector: {
      namespaced: true,
      ...template_connector
    },
    model: {
      namespaced: true,
      ...model
    },
    template_attribute: {
      namespaced: true,
      ...template_attribute
    },
    element: {
      namespaced: true,
      ...element
    },
    element_attribute: {
      namespaced: true,
      ...element_attribute
    },
    element_connector: {
      namespaced: true,
      ...element_connector
    },
    card: {
      namespaced: true,
      ...card
    },
    merchant: {
      namespaced: true,
      ...merchant
    },
    reference: {
      namespaced: true,
      ...reference
    },
    filter: {
      namespaced: true,
      ...filter
    },
    kanguro: {
      namespaced: true,
      ...kanguro
    },
    message: {
      namespaced: true,
      ...message
    },
    suggestion: {
      namespaced: true,
      ...suggestion
    },
    knowledge: {
      namespaced: true,
      ...knowledge
    },
    contact: {
      namespaced: true,
      ...contact
    },
    stripe: {
      namespaced: true,
      ...stripe
    },
    paypal: {
      namespaced: true,
      ...paypal
    },
    certification_exam: {
      namespaced: true,
      ...certification_exam
    },
    notification: {
      namespaced: true,
      ...notification
    },
    insights: {
      namespaced: true,
      ...insights
    },
    feedback: {
      namespaced: true,
      ...feedback
    },
    objective: {
      namespaced: true,
      ...objective
    },
    list: {
      namespaced: true,
      ...list
    },
    graph_answer: {
      namespaced: true,
      ...graph_answer
    },
    message_template: {
      namespaced: true,
      ...message_template
    },
    response_block: {
      namespaced: true,
      ...response_block
    },
    activity_log: {
      namespaced: true,
      ...activity_log
    },
    voicebot: {
      namespaced: true,
      ...voicebot
    },
    alexa: {
      namespaced: true,
      ...alexa
    },
    webhook: {
      namespaced: true,
      ...webhook
    },
    api_user: {
      namespaced: true,
      ...api_user
    },
    functions: {
      namespaced: true,
      ...functions
    },
    inbox_filters: {
      namespaced: true,
      ...inbox_filters
    },
    whatsapp: {
      namespaced: true,
      ...whatsapp
    },
    permission: {
      namespaced: true,
      ...permissions
    },
    products_package: {
      namespaced: true,
      ...productsPackage
    },
    document: {
      namespaced: true,
      ...documents
    },
    bills: {
      namespaced: true,
      ...bills
    },
    property: {
      namespaced: true,
      ...property
    },
    property_filter: {
      namespaced: true,
      ...property_filter
    },
    googleapis_credential: {
      namespaced: true,
      ...googleapis_credential
    }
  }
})
